module.exports = __webpack_public_path__ + "img/banner.e70f9803.png";